export const ZIP_CODE_PATTERNS = {
    AT: /^\d{4}$/,
    AM: /^\d{4}$/,
    AU: /^\d{4}$/,
    AZ: /^\d{4}$/,
    BA: /^\d{5}$/,
    BE: /^\d{4}$/,
    BG: /^\d{4}$/,
    BR: /^\d{5}-\d{3}$/,
    CA: /^(?!.*[DFIOQU])[A-VXY]\d[A-Z] ?\d[A-Z]\d$/,
    CH: /^\d{4}$/,
    CY: /^\d{4}$/,
    CN: /^\d{6}$/,
    CO: /^\d{6}$/,
    CZ: /^\d{3} {0,1}\d{2}$/,
    DE: /^\d{5}$/,
    DO: /^\d{5}$/,
    DK: /^\d{4}$/,
    DZ: /^\d{5}$/,
    EE: /^\d{5}$/,
    ES: /^\d{5}$/,
    ESCN: /^\d{5}$/,
    FI: /^(FI-){0,1}\d{5}$/,
    FR: /^\d{5}$/,
    GB: /^(GIR 0AA|[A-PR-UWYZ](\d{1,2}|([A-HK-Y]\d|[A-HK-Y]\d(\d|[ABEHMNPRV-Y]))|\d[A-HJKS-UW]) {0,1}\d[ABD-HJLNP-UW-Z]{2})$/,
    GE: /^\d{4}$/,
    GR: /^(\d{5}|\d{3}\s\d{2})$/,
    HK: /^\d{0,20}$/,
    HR: /^(HR-){0,1}\d{5}$/,
    HU: /^(H-){0,1}\d{4}$/,
    ID: /^\d{5}$/,
    IC: /^\d{5}$/,
    IE: /^.{1,16}$/,
    IN: /^\d{6}$/,
    IT: /^\d{5}$/,
    JP: /^(\d){3}-(\d){4}$/,
    KR: /^(\d{5})|((\d){3}-(\d){3})$/,
    KZ: /^\d{6}$/,
    LT: /^(LT-){0,1}\d{5}$/,
    LU: /^(L-)?\d{4}$/,
    LV: /^(LV-){0,1}\d{4}$/,
    MC: /^\d{5}$/,
    MK: /^\d{4}$/,
    MT: /^[A-Z]{3}\s?\d{4}$/,
    MX: /^\d{5}$/,
    MY: /^\d{5}$/,
    NL: /^\d{4}\s?[A-Z]{2}$/,
    NO: /^\d{4}$/,
    PH: /^\d{4}$/,
    PL: /^\d{2}-\d{3}$/,
    PT: /^\d{4}-\d{3}$/,
    RS: /^\d{5}$/,
    RU: /^\d{6}$/,
    SA: /^\d{5}$/,
    SE: /^\d{3} ?\d{2}$/,
    SG: /^\d{6}$/,
    SI: /^(SI-){0,1}\d{4}$/,
    SK: /^\d{3} {0,1}\d{2}$/,
    TH: /^\d{5}$/,
    TN: /^\d{4}$/,
    TR: /^\d{5}$/,
    TW: /^\d{3}$/,
    UA: /^\d{5}$/,
    US: /^\d{5}$/,
    UZ: /^\d{6}$/,
    RO: /^\d{6}$/,
};
